export default {
  isLogged(store) {
    return store.authToken && store.authToken !== '';
  },
};
